var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "object-info-card",
      style: { "max-height": _vm.height, height: _vm.height }
    },
    [
      _c("div", { staticClass: "card-header" }, [
        _c(
          "div",
          { staticClass: "card-title" },
          [
            _vm._t("before-title-slot"),
            _vm._v(" "),
            !_vm.editingData
              ? _c(
                  "div",
                  [
                    _vm._t("object-image-slot"),
                    _vm._v(" "),
                    _vm.identifierLabel
                      ? _c("span", { staticClass: "title-label" }, [
                          _vm._v(_vm._s(_vm.identifierLabel) + ":")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "title-reference" }, [
                      _vm._v(_vm._s(_vm.identifier))
                    ])
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editingData
              ? _c("span", { staticClass: "title-label" }, [
                  _vm._v(_vm._s(_vm.$t(_vm.cardLabel)))
                ])
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons-container" },
          [
            _vm._t("buttons-before-edit-slot"),
            _vm._v(" "),
            _vm.showEditButton
              ? _c("custom-button", {
                  attrs: {
                    icon: "mdi-pencil",
                    "icon-size": 13,
                    "icon-color": _vm.editingData
                      ? "var(--app-primary-base)"
                      : "#FFFFFF",
                    "button-color": _vm.editingData
                      ? "#FFFFFF"
                      : "var(--app-primary-base)",
                    height: "20px",
                    width: "20px",
                    "button-styling": _vm.buttonStyling
                  },
                  on: {
                    buttonClick: function($event) {
                      return _vm.$emit("toggle-edit")
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._t("buttons-after-edit-slot")
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-info", style: { "overflow-y": "visible" } },
        [
          _vm._t("before-fields-slot"),
          _vm._v(" "),
          _vm._l(_vm.fields, function(field) {
            return _c(
              "div",
              {
                key: field.label,
                staticClass: "card-info-item-container",
                style: [
                  {
                    width: field.size ? field.size : 100 / 3 + "%",
                    overflow: _vm.editingData ? "visible" : "hidden"
                  }
                ]
              },
              [
                !_vm.editingData
                  ? _c("v-icon", [_vm._v(_vm._s(field.icon))])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "card-info-item",
                    style: _vm.cardInfoItemStyling
                  },
                  [
                    _vm.editingData
                      ? _c("input-field", {
                          key: field.varName,
                          attrs: {
                            "input-type": field.inputType,
                            value: field.value,
                            label: field.label,
                            treeSelectPlaceHolder: field.placeholder
                              ? field.placeholder
                              : null,
                            "input-disabled": field.disabled,
                            "select-options-list": field.options,
                            disableBranchNodes: field.disableBranchNodes,
                            "checkbox-options": field.checkboxOptions,
                            min: field.min,
                            max: field.max,
                            step: field.step,
                            size: "large",
                            clearable: field.clearable,
                            required: field.required,
                            inputFieldContainerStyling: { padding: "0" },
                            radioOptions:
                              field.inputType === "radio"
                                ? field.radioOptions
                                : null,
                            validationObject: field.validation
                              ? field.validation
                              : null
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateField($event, field)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.editingData && field.varName !== "sm_reference"
                      ? _c("span", { staticClass: "card-info-item-label" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(field.label) +
                              ": \n        "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.editingData && _vm.fieldIsBarcodeField(field.label)
                      ? _c("img", {
                          attrs: {
                            src: require("../../assets/barcode.png"),
                            alt: field.value
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.editingData && field.varName !== "sm_reference"
                      ? _c("span", { staticClass: "card-info-item-value" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                Array.isArray(field.value)
                                  ? field.value[0].name
                                  : field.value
                              ) +
                              "\n        "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.editingData && _vm.showEditActionButtons
        ? _c(
            "div",
            { staticClass: "action-buttons" },
            [
              _vm.isWorkspaceObject
                ? _c("custom-button", {
                    attrs: {
                      icon: "mdi-eye",
                      height: "26px",
                      iconSize: 12,
                      width: "135px",
                      buttonStyling: _vm.actionButtonsStyling,
                      label: _vm.$t("ViewAllWorkspaces")
                    },
                    on: { buttonClick: _vm.signalShowAllWorkspaces }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("custom-button", {
                attrs: {
                  label: _vm.$t("Cancel"),
                  "button-color": "#FFF",
                  "label-color": "var(--app-primary-base)",
                  "button-styling": _vm.actionButtonsStylingCancel
                },
                on: {
                  buttonClick: function($event) {
                    return _vm.$emit("cancel-edit")
                  }
                }
              }),
              _vm._v(" "),
              _c("custom-button", {
                attrs: {
                  label: _vm.$t(_vm.submitButtonLabel),
                  "button-color": "var(--app-primary-base)",
                  "label-color": "#FFF",
                  "button-styling": _vm.actionButtonsStylingSave,
                  disabled: !_vm.requiredFieldsFilled
                },
                on: {
                  buttonClick: function($event) {
                    return _vm.$emit("save-object")
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06ff499e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06ff499e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Organisms/ObjectMainInfo.vue
// module id = null
// module chunks = 